import { shellStringResources } from '../../Resources/ShellStringResources';
import { format, stringIsNullOrEmpty } from '../../shared/utils/string.util';
import { IModel } from '../base/annotation';
import { Metamodel } from '../base/model';
import { ExpressCustomSetup, expressCustomSetupTypes } from './expressCustomSetup';

@Metamodel.model({
    name: 'EnvironmentVariable',
    display: [shellStringResources.ModelName_EnvVariableExtension, shellStringResources.ModelName_EnvVariableExtensions]
})
export class EnvironmentVariableSetup extends ExpressCustomSetup {
    public static readonly MODEL: IModel;

    public variableName: string;
    public variableValue: string;

    constructor(name?: string, public description?: string) {
        super(expressCustomSetupTypes.EnvVariable, name, description);
    }
    public getCustomSetupName(): string {
        return format(shellStringResources.IRCreation_SSIS_CustomSetup_EnvrionmentVariable_Format, this.variableName, this.variableValue);
    }

    public coincideWith(customSetup: ExpressCustomSetup): void {
        if (this.customSetupType === customSetup.customSetupType) {
            const setup = customSetup as EnvironmentVariableSetup;
            this.variableName = setup.variableName;
            this.variableValue = setup.variableValue;
        }
    }

    public validate(): boolean {
        return this.isValidProperty(this.variableName) && this.isValidProperty(this.variableValue);
    }

    private isValidProperty(property: string): boolean {
        return !stringIsNullOrEmpty(property) && property.indexOf(' ') === -1;
    }
}
